export default __webpack_public_path__ + "static/media/diego.9e813e40.jpg";